/* unplugin-vue-components disabled */import script from "./BackstagePage.vue?vue&type=script&setup=true&lang=js"
export * from "./BackstagePage.vue?vue&type=script&setup=true&lang=js"

import "./BackstagePage.vue?vue&type=style&index=0&id=c49626d4&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c49626d4"]])

export default __exports__